import {isPerpetualVariant, PERPETUAL_ATS_THRESHOLD} from './cover-stock-display';
import {getInventory, INVENTORY_STATUS, isMtoOrderableProduct, resolveEntityAts} from './inventory-utils';

/**
 * Which PDP stock row to render (UI), derived from inventory.
 *
 * @enum {string}
 */
export const STOCK_INDICATOR = Object.freeze({
  IN_STOCK: 'in-stock',
  LOW_STOCK: 'low-stock',
  OUT_OF_STOCK: 'out-of-stock',
  NONE: 'none',
});

/**
 * PDP stock row variant for {@link ProductStockIndicator}.
 *
 * @param {Object|null|undefined} product
 * @param {Object|null|undefined} variant
 * @param {string|undefined|null} [inventoryIdsFromCookie] - IM-004 formatted `inventoryIds`
 * @returns {'in-stock'|'low-stock'|'out-of-stock'|'none'}
 */
export const getPdpStockIndicator = (product, variant, inventoryIdsFromCookie) => {
  if (!product) {
    return STOCK_INDICATOR.NONE;
  }

  const entity =
    variant?.inventory || variant?.ats !== undefined || variant?.orderable !== undefined ?
      variant :
      product;
  const ats = resolveEntityAts(entity, inventoryIdsFromCookie);

  // Hide the stock row when there is no real warehouse ATS (MTO/deposit: null/N/A, perpetual, or SFCC sentinel).
  if (
    isPerpetualVariant(entity) ||
    isMtoOrderableProduct(entity) ||
    ats == null ||
    ats === 999999 ||
    ats >= PERPETUAL_ATS_THRESHOLD
  ) {
    return STOCK_INDICATOR.NONE;
  }

  const {status} = getInventory(product, variant, inventoryIdsFromCookie);

  if (status === INVENTORY_STATUS.IN_STOCK) return STOCK_INDICATOR.IN_STOCK;
  if (status === INVENTORY_STATUS.LOW_STOCK) return STOCK_INDICATOR.LOW_STOCK;
  if (status === INVENTORY_STATUS.OUT_OF_STOCK) return STOCK_INDICATOR.OUT_OF_STOCK;

  return STOCK_INDICATOR.NONE;
};
